import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncrDecrService } from './encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  myProfileAPIuri: string = 'my-profile/';
  userDeleteAPIuri: string = 'user-delete/';
  notificationSettingAPIuri: string = 'notification-setting/';
  updateProfileAPIuri: string = 'update-profile/';
  updatePasswordAPIuri: string = 'update-password/';
  resetPasswordAPIuri: string = 'reset-password';

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { }

  getProfile() {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + this.myProfileAPIuri + user.id, { headers: headers_object }).toPromise()
  }

  userDelete() {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.userDeleteAPIuri + user.id, {}, { headers: headers_object }).toPromise()
  }

  notificationSetting(status: number) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    this.http.post(environment.apiURI + this.notificationSettingAPIuri + user.id,
      {
        'notification': status
      },
      { headers: headers_object }).toPromise()
  }

  updateProfile(formData) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.updateProfileAPIuri + user.id, formData, { headers: headers_object }).toPromise()
  }

  updatePassword(data) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.updatePasswordAPIuri + user.id, data, { headers: headers_object }).toPromise();
  }

  resetPassword(data) {
    return this.http.post(environment.apiURI + this.resetPasswordAPIuri, data).toPromise();
  }
}
